// TODO: documentazione
export class ErrorDefault {
  async parse() {
    return null;
  }
}

export const errorDefault = new ErrorDefault();
